import type { RowType } from '@tryhackme/thm-ui-components';

import type { DataResponse } from 'src/features/manage-room/manage-room.types';

export const formattedWriteupData = (data: DataResponse): RowType[] =>
  data?.docs?.map((obj) => ({
    _id: obj._id,
    status: obj.status,
    title: obj.title,
    link: obj.link,
    posted: obj.posted,
    addedDate: obj.addedDate,
    id: obj._id,
    userId: obj.user._id,
    ...obj.user.local,
  }));
